import { useLocation, useNavigate } from "react-router-dom";
import Footer from "../../components/footer";
import Menu from "../../components/menu";
import useAuth from "../../hooks/useAuth";
import styles from './adicionarLivro.module.css'
import { useEffect, useRef, useState } from "react";

import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { authApi } from "../../services/api/api";

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import AddBoxIcon from '@mui/icons-material/AddBox';
import { ImageIcon, PlusSquare, Save, Trash2, X } from "lucide-react";

interface AdicionarLivroProps {
    bookData?: any; // Dados do livro para edição (opcional)
    onSuccess?: () => void; // Callback para fechar o modal ou limpar lista
}
export default function AdicionarLivro({ bookData, onSuccess }: AdicionarLivroProps) {

    const api = authApi()

    const { state } = useLocation()

    const navigate = useNavigate()


    const { user, theme, storeBook } = useAuth()

    const [file, setfile] = useState(state ? state.img : '')
    const [image, setImage] = useState(null)

    const [gen, setGen] = useState(state ? state.gen : '')
    const [title, setTitle] = useState(state ? state.title : '')
    const [autor, setAutor] = useState(state ? state.autor : '')
    const [cod, setCod] = useState('')
    const [edition, setEdition] = useState(state ? state.edition : '')
    const [editora, setEditora] = useState(state ? state.editora : '')
    const [year, setYear] = useState(state ? state.year : '')
    const [exemplares, setExemplares] = useState(state ? state.exemplaries.length : '')
    const [summary, setSummary] = useState(state ? state.summary : '')

    let inputRef = useRef<HTMLInputElement>(null)
    // --- LOGICA UNIFICADA ---
    // Se bookData existe (Modal), usamos ele. Se não, usamos o state (Navegação).
    const currentBook = bookData || state;
    const isEditing = !!currentBook;
    // Dentro do componente AdicionarLivro
    const [status, setStatus] = useState(currentBook?.status ?? 0); // 1 = Ativo por padrão
    const [open, setOpen] = useState(false);

    useEffect(() => {
        console.log(state)
        if (bookData) {
            setTitle(bookData.title || "");
            setAutor(bookData.autor || "");
            setEditora(bookData.editora || "");
            setYear(bookData.year || "");
            setEdition(bookData.edition || "");
            setGen(bookData.gen || "");
            setSummary(bookData.summary || "");
            setExemplares(bookData.exemplaries?.length || 1);
            setImage(bookData.img || null); // Carrega a thumb atual
            setfile(bookData.img || "");
            setStatus(bookData.status ?? 0);
        }
    }, [bookData]);
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    function handleImg() {
        if (inputRef) {
            inputRef.current?.click()
        }
    }

    function handleFile(e: React.ChangeEvent<HTMLInputElement>) {
        const selectedFiles = e.target.files as FileList

        if (selectedFiles?.[0].size > 1048576) {
            toast.error('A imagem não pode ultrapassar 1mb.', { theme: 'dark', toastId: 'password' })
            return
        }

        setfile(URL.createObjectURL(selectedFiles?.[0]))

        setImage(e.target.files[0])

        if (e.target.files) {

            const files = e.target.files[0]


            const reader = new FileReader()
            reader.readAsBinaryString(e.target.files[0])
            reader.onload = (ev: any) => {
                setImage(`data:${files.type};base64,${btoa(ev.target.result)}`)
            }
        }
    }

    async function handleSave(e: any) {
        e.preventDefault();

        // --- Validações (Mantenha como estão) ---
        if (gen === '') { toast.info('Selecione o Gênero.', { theme: 'dark', toastId: 'gen' }); return; }
        if (title === '') { toast.info('Insira o Título.', { theme: 'dark', toastId: 'title' }); return; }
        if (autor === '') { toast.info('Insira o Autor.', { theme: 'dark', toastId: 'autor' }); return; }
        if (edition === '') { toast.info('Insira a Edição.', { theme: 'dark', toastId: 'edition' }); return; }
        if (editora === '') { toast.info('Insira a Editora.', { theme: 'dark', toastId: 'editora' }); return; }
        if (year === '') { toast.info('Insira o Ano.', { theme: 'dark', toastId: 'year' }); return; }
        if (exemplares === '') { toast.info('Insira a quantidade de exemplares.', { theme: 'dark', toastId: 'exemplares' }); return; }
        if (summary === '') { toast.info('Insira o resumo.', { theme: 'dark', toastId: 'summary' }); return; }
        if (file === '') { toast.info('Insira a imagem de capa.', { theme: 'dark', toastId: 'image' }); return; }

        const data = {
            'gen': gen,
            'title': title,
            'autor': autor,
            'editora': editora,
            'cod': cod,
            'edition': edition,
            'year': year,
            'exemplares': exemplares,
            'summary': summary,
            'image': image, // Certifique-se que 'image' contém o base64
            'id': user?.id,
            'book_id': currentBook?.id ?? '',
            'status': status, // Enviamos o número 0 ou 1 que está no estado
        };
        // console.log(data)
        // return;
        const clearForm = () => {
            setTitle('');
            setGen('');
            setAutor('');
            setEdition('');
            setEditora('');
            setYear('');
            setExemplares(1);
            setSummary('');
            setfile(''); // Limpa o preview visual
            if (inputRef.current) inputRef.current.value = ""; // Limpa o input file
        };

        try {
            let resp = isEditing ? await api.updateBook(data) : await storeBook(data);

            console.log("Resposta completa da API:", resp); // Adicione este log para depurar

            // Verifica se o status está em qualquer um desses lugares comuns
            const statusCode = resp?.status || resp?.data?.status;
            const successMsg = resp?.message || resp?.data?.message || 'Operação realizada com sucesso!';

            if (statusCode == 200 || statusCode == 201) {
                // USANDO A MENSAGEM DA API AQUI:
                toast.success(successMsg, { theme: 'dark' });

                clearForm();
                if (onSuccess) {
                    setTimeout(() => onSuccess(), 500);
                }
            } else {
                // Caso o status não seja sucesso, tentamos pegar a mensagem de erro da API também
                const errorApiMsg = resp?.message || 'Erro inesperado do servidor.';
                toast.error(errorApiMsg, { theme: 'dark' });
            }

        } catch (error: any) {
            console.error("Caiu no Catch:", error);
            const errorMsg = error.response?.data?.message || "Erro de conexão com o servidor.";
            toast.error(errorMsg, { theme: 'dark' });
        }
    }

    async function handleDelete() {

        const response = await api.deleteBook(state.id)

        if (response == 200) {
            toast.success('Livro excluido com sucesso!', { theme: 'dark', toastId: 'successDelete' })
            handleClose()
            navigate('/biblioteca')
        } else {
            toast.error('Não foi possivel excluir o livro.', { theme: 'dark', toastId: 'errorDelete' })
            handleClose()
        }
    }

    return (
        <div className={`${theme}  overflow-x-hidden  w-full flex flex-col justify-center `}>

            <div className="flex justify-center flex-col">
                <form className="w-full animate-in fade-in slide-in-from-bottom-4 duration-700 pb-24 md:pb-0">
                    <div className={`bg-white dark:bg-[#2d3d5780] shadow border border-gray-100 dark:border-white/5 overflow-hidden ${isEditing ? 'dark:bg-white border-0 shadow-none' : ''}`}>

                        <div className={`flex flex-col gap-8 ${isEditing ? 'p-1' : 'p-8'}`}>
                            <div className={`flex gap-10 ${styles.displayColumn} items-start`}>

                                {/* --- COLUNA DA ESQUERDA (IMAGEM E BOTÕES DESKTOP) --- */}
                                <div className="flex flex-col justify-center items-center xs:w-full md:w-auto">
                                    <div className="flex flex-col items-center gap-3 w-full lg:w-[300px] mb-4">
                                        <label className={`text-[10px] font-black uppercase tracking-[0.2em] text-gray-400 dark:text-white self-center md:self-start ml-2 ${isEditing ? 'dark:!text-gray-600' : ''}`}>
                                            Capa do Livro
                                        </label>
                                        <button
                                            type="button"
                                            onClick={handleImg}
                                            className={`relative group md:w-64 w-44 aspect-[3/4] rounded-2xl border-2 border-dashed border-gray-200 dark:border-white/10 hover:border-blue-500 dark:hover:border-blue-400 transition-all flex flex-col items-center justify-center bg-gray-50 dark:bg-white/5 overflow-hidden shadow-inner ${isEditing ? ' dark:!bg-gray-200/30 dark:!text-gray-900 dark:!border-gray-300/20' : ''}`}
                                        >
                                            {file ? (
                                                <img src={file} alt="Preview" className="w-full h-full object-contain p-3 transition-transform duration-500 group-hover:scale-105" />
                                            ) : (
                                                <div className="flex flex-col items-center text-gray-400 group-hover:text-blue-500 transition-colors">
                                                    <ImageIcon size={48} strokeWidth={1} />
                                                    <span className="text-[10px] mt-4 font-bold uppercase tracking-widest text-center px-4">
                                                        Selecionar imagem <br /> 300x500
                                                    </span>
                                                </div>
                                            )}
                                            <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center text-white text-xs font-bold uppercase">
                                                Alterar Capa
                                            </div>
                                        </button>
                                        <input name="image" type="file" accept="image/*" className="hidden" ref={inputRef} onChange={handleFile} />
                                    </div>

                                    {/* Checkbox de Status */}
                                    <div className="flex items-center gap-2 mb-4 ml-2">
                                        <input
                                            type="checkbox"
                                            checked={status == 1}
                                            onChange={(e) => setStatus(e.target.checked ? 1 : 0)}
                                            className="w-4 h-4"
                                        />
                                        <label className={`text-[10px] font-black uppercase tracking-widest text-gray-400 dark:text-white ${isEditing ? ' dark:!text-gray-700' : ''}`}>
                                            {status == 1 ? 'Removido do catálogo' : 'Remover do catálogo'}
                                        </label>
                                    </div>

                                    {/* BOTÕES DESKTOP (md:flex) - Ficam embaixo da imagem no computador */}
                                    <div className={`hidden w-full md:flex flex-col gap-4 border-t border-gray-100 dark:border-white/5 ${!isEditing ? 'flex ' : ''}`}>
                                        <button
                                            onClick={handleSave}
                                            type="button"
                                            className="flex-1  py-4 px-4 bg-gradient-to-r bg-blue3 hover:bg-blue4 text-white font-bold rounded-xl shadow shadow-blue-500/20 flex items-center justify-center gap-3 transition-all active:scale-95 uppercase tracking-widest text-xs"
                                        >
                                            {isEditing ? 'Atualizar Dados' : 'Cadastrar Livro'}
                                        </button>

                                        {isEditing && (
                                            <button
                                                onClick={handleClickOpen}
                                                type="button"
                                                className="px-4  py-4 bg-red-50 dark:bg-red-500/10 text-red-500 hover:bg-red-500 hover:text-white font-bold rounded-2xl flex items-center justify-center gap-3 transition-all active:scale-95 uppercase tracking-widest text-xs"
                                            >
                                                Deletar
                                            </button>
                                        )}
                                    </div>
                                </div>

                                {/* --- COLUNA DA DIREITA (TODOS OS INPUTS RESTAURADOS) --- */}
                                <div className="flex-1 flex flex-col gap-5 w-full">

                                    {/* Título */}
                                    <div className="flex flex-col gap-2">
                                        <label className={`text-[10px] font-black uppercase tracking-[0.2em] dark:text-white ml-2 ${isEditing ? ' dark:!text-gray-600 ' : ''}`}>Título do Livro</label>
                                        <input
                                            style={{ textTransform: 'uppercase' }}
                                            className={`w-full p-2.5 rounded-2xl bg-gray-100 text-sm dark:bg-white/5 border border-gray-200 dark:border-white/5 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 outline-none transition-all font-medium ${isEditing ? ' dark:!bg-gray-200/30 dark:!text-gray-900 dark:!border-gray-300/20' : ''}`}
                                            type="text"
                                            onChange={(e) => setTitle(e.target.value)}
                                            value={title}
                                            placeholder="EX: O PODER DO HÁBITO"
                                        />
                                    </div>

                                    {/* Gênero e Autor */}
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div className="flex flex-col gap-2">
                                            <label className={`text-[10px] font-black uppercase tracking-[0.2em] text-gray-400 dark:text-white ml-2 ${isEditing ? ' dark:!text-gray-600' : ''}`}>Gênero</label>
                                            <select
                                                value={gen}
                                                className={`w-full p-2.5 rounded-2xl bg-gray-50 text-sm dark:bg-white/5 border border-gray-200 dark:border-white/5 text-gray-900 dark:text-white outline-none focus:ring-2 focus:ring-blue-500 ${isEditing ? ' dark:!bg-gray-200/30 dark:!text-gray-900 dark:!border-gray-300/20' : ''}`}
                                                onChange={(e) => setGen(e.target.value)}
                                            >
                                                <option className="dark:text-gray-600" value="">Selecione...</option>
                                                <option className="dark:text-gray-600" value="Ação e aventura">Ação e aventura</option>
                                                <option className="dark:text-gray-600" value="Auto Ajuda">Auto Ajuda</option>
                                                <option className="dark:text-gray-600" value="Biografia">Biografia</option>
                                                <option className="dark:text-gray-600" value="Fantasia">Fantasia</option>
                                                <option className="dark:text-gray-600" value="Ficção Científica">Ficção Científica</option>
                                                <option className="dark:text-gray-600" value="Filosofia">Filosofia</option>
                                                <option className="dark:text-gray-600" value="Romance">Romance</option>
                                                <option className="dark:text-gray-600" value="Negócios">Negócios</option>
                                            </select>
                                        </div>
                                        <div className="flex flex-col gap-2">
                                            <label className={`text-[10px] font-black uppercase tracking-[0.2em] text-gray-400 dark:text-white ml-2 ${isEditing ? ' dark:!text-gray-600' : ''}`}>Autor</label>
                                            <input
                                                style={{ textTransform: 'uppercase' }}
                                                className={`w-full p-2.5 rounded-2xl bg-gray-50 text-sm dark:bg-white/5 border border-gray-200 dark:border-white/5 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 outline-none transition-all ${isEditing ? ' dark:!bg-gray-200/30 dark:!text-gray-900 dark:!border-gray-300/20' : ''}`}
                                                type="text"
                                                onChange={(e) => setAutor(e.target.value)}
                                                value={autor}
                                            />
                                        </div>
                                    </div>

                                    {/* Edição e Editora */}
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div className="flex flex-col gap-2">
                                            <label className={`text-[10px] font-black uppercase tracking-[0.2em] text-gray-400 dark:text-white ml-2 ${isEditing ? ' dark:!text-gray-600' : ''}`}>Edição</label>
                                            <input className={`w-full p-2.5 rounded-2xl text-sm bg-gray-50 dark:bg-white/5 border border-gray-200 dark:border-white/5 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 outline-none transition-all ${isEditing ? ' dark:!bg-gray-200/30 dark:!text-gray-900 dark:!border-gray-300/20' : ''}`} type="text" onChange={(e) => setEdition(e.target.value)} value={edition} />
                                        </div>
                                        <div className="flex flex-col gap-2">
                                            <label className={`text-[10px] font-black uppercase tracking-[0.2em] text-gray-400 dark:text-white ml-2 ${isEditing ? ' dark:!text-gray-600' : ''}`}>Editora</label>
                                            <input style={{ textTransform: 'uppercase' }} className={`w-full text-sm p-2.5 rounded-2xl bg-gray-50 dark:bg-white/5 border border-gray-200 dark:border-white/5 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 outline-none transition-all ${isEditing ? ' dark:!bg-gray-200/30 dark:!text-gray-900 dark:!border-gray-300/20' : ''}`} type="text" onChange={(e) => setEditora(e.target.value)} value={editora} />
                                        </div>
                                    </div>

                                    {/* Ano e Exemplares */}
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div className="flex flex-col gap-2">
                                            <label className={`text-[10px] font-black uppercase tracking-[0.2em] text-gray-400 dark:text-white ml-2 ${isEditing ? ' dark:!text-gray-600' : ''}`}>Ano de Lançamento</label>
                                            <input className={`w-full p-2.5 text-sm rounded-2xl bg-gray-50 dark:bg-white/5 border border-gray-200 dark:border-white/5 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 outline-none transition-all ${isEditing ? ' dark:!bg-gray-200/30 dark:!text-gray-900 dark:!border-gray-300/20' : ''}`} type="date" onChange={(e) => setYear(e.target.value)} value={year} />
                                        </div>
                                        <div className="flex flex-col gap-2">
                                            <label className={`text-[10px] font-black uppercase tracking-[0.2em] text-gray-400 dark:text-white ml-2 ${isEditing ? ' dark:!text-gray-600' : ''}`}>Qtd. Exemplares</label>
                                            <div className="flex items-center gap-2">
                                                <input readOnly={!!state} type="number" className={`flex-1 p-2.5 text-sm rounded-2xl bg-gray-50 dark:bg-white/5 border border-gray-200 dark:border-white/5 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 outline-none ${isEditing ? ' dark:!bg-gray-200/30 dark:!text-gray-900 dark:!border-gray-300/20' : ''}`} onChange={(e) => setExemplares(e.target.value)} value={exemplares} />
                                                {state && (
                                                    <button
                                                        type="button"
                                                        onClick={() => setExemplares((old) => Number(old) + 1)}
                                                        className="p-4 rounded-2xl bg-emerald-500/10 text-emerald-500 hover:bg-emerald-500 transition-all"
                                                    >
                                                        <AddBoxIcon />
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Sinopse */}
                                    <div className="flex flex-col gap-2">
                                        <label className={`text-[10px] font-black uppercase tracking-[0.2em] text-gray-400 dark:text-white ml-2 ${isEditing ? ' dark:!text-gray-600' : ''}`}>Resumo / Sinopse</label>
                                        <textarea
                                            className={`w-full p-2.5 text-sm h-44 rounded-2xl bg-gray-50 dark:bg-white/5 border border-gray-200 dark:border-white/5 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 outline-none transition-all ${isEditing ? ' dark:!bg-gray-200/30 dark:!text-gray-900 dark:!border-gray-300/20' : ''}`}
                                            onChange={(e) => setSummary(e.target.value)}
                                            value={summary}
                                            placeholder="Descreva brevemente a obra..."
                                        ></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* --- BOTÕES MOBILE (md:hidden) - Fixos no fundo apenas no celular em modo edição --- */}
                        {isEditing && (
                            <div className="md:hidden fixed bottom-0 left-0 w-full p-4 bg-white/90 backdrop-blur-md border-t border-gray-100 flex gap-3 z-50">
                                <button
                                    onClick={handleSave}
                                    type="button"
                                    className="flex-1 py-4 bg-blue3 text-white font-bold rounded-xl text-xs uppercase tracking-widest shadow-lg active:scale-95 transition-all"
                                >
                                    Atualizar
                                </button>
                                <button
                                    onClick={handleClickOpen}
                                    type="button"
                                    className="flex-1 py-4 bg-red-50 text-red-500 font-bold rounded-xl text-xs uppercase tracking-widest border border-red-100 active:scale-95 transition-all"
                                >
                                    Deletar
                                </button>
                            </div>
                        )}
                    </div>
                </form>
            </div>


            {/* <Footer/> */}

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                // Customização do corpo do modal para garantir consistência
                PaperProps={{
                    style: {
                        borderRadius: '32px', // Bordas mais arredondadas igual ao form
                        backgroundImage: 'none',
                        overflow: 'hidden', // Importante para o cabeçalho não vazar
                        border: theme === 'dark' ? '1px solid rgba(255, 255, 255, 0.05)' : '1px solid rgba(0, 0, 0, 0.05)',
                    },
                }}
            >
                {/* CABEÇALHO PADRONIZADO COM BACKGROUND E EFEITO GLASS */}
                <div className="bg-gradient-to-r from-red-600 to-red-800 px-6 py-5 flex justify-between items-center shadow-lg border-b border-red-900/10">
                    <div className="flex items-center gap-3">
                        <div className="bg-white/10 p-2.5 rounded-xl backdrop-blur-md">
                            <Trash2 className="text-white" size={20} />
                        </div>
                        <div>
                            <h2 className="text-lg font-bold text-white tracking-tight leading-tight">
                                Confirmar Exclusão
                            </h2>
                            <p className="text-red-100 text-[10px] uppercase tracking-[0.2em] font-medium mt-0.5">
                                Ação Irreversível
                            </p>
                        </div>
                    </div>
                    <button
                        onClick={handleClose}
                        className="text-red-100 hover:text-white p-1 rounded-full hover:bg-white/10 transition-all"
                    >
                        <X size={20} />
                    </button>
                </div>

                {/* CONTEÚDO DO MODAL */}
                <DialogContent className="pt-8 pb-4">
                    <div className="mt-2 text-center">
                        <p className="text-gray-500 dark:text-gray-400 text-sm leading-relaxed px-4">
                            Você está prestes a remover permanentemente a seguinte obra do acervo. Tem certeza?
                        </p>

                        <div className="mt-6 p-5 bg-gray-50 dark:bg-white/5 rounded-2xl border border-gray-100 dark:border-white/5 shadow-inner">
                            <span className="text-blue-600 dark:text-blue-400 font-bold uppercase text-[11px] tracking-wider mb-2 block">
                                {state?.id ? `#${state.id} |` : ''} TÍTULO DO LIVRO
                            </span>
                            <h3 className="text-slate-800 dark:text-white font-black text-xl uppercase leading-tight mt-1 px-2">
                                {state?.title}
                            </h3>
                        </div>

                        <p className="mt-5 text-[10px] text-red-500 font-bold uppercase tracking-[0.3em] text-center p-3 rounded-full inline-block mx-auto">
                            Atenção: Esta ação não poderá ser desfeita.
                        </p>
                    </div>
                </DialogContent>

                {/* AÇÕES FINAIS (BOTÕES) */}
                <DialogActions className="p-6 pt-2 gap-3 flex flex-col sm:flex-row border-t border-gray-100">
                    <div className="flex w-full my-2">
                        <button
                            onClick={handleClose}
                            type="button"
                            className="w-full sm:flex-1 h-12 rounded-xl text-xs font-bold uppercase tracking-widest text-gray-500 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-white/5 transition-all"
                        >
                            Cancelar
                        </button>
                        <button
                            onClick={handleDelete}
                            type="button"
                            className="w-full sm:flex-1 h-12 rounded-xl text-xs font-bold uppercase tracking-widest bg-red-600 hover:bg-red-700 text-white shadow-lg shadow-red-500/20 active:scale-[0.98] transition-all flex items-center justify-center gap-2"
                        >
                            Sim, Deletar Livro
                        </button>
                    </div>
                </DialogActions>
            </Dialog>


        </div>
    )


}